var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.getData),expression:"getData"}],staticClass:"msgError",style:({height:_vm.height}),attrs:{"id":_vm.id},domProps:{"value":(_vm.getData)},on:{"input":function($event){if($event.target.composing){ return; }_vm.getData=$event.target.value}}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-219cc56a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/tinymce.vue
// module id = null
// module chunks = 